import React, { useState, useEffect } from "react";
import { MdOutlineQueue, MdEdit } from "react-icons/md";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../Context/LanguageContext";
import EmailGroupCreatre from "./EmailGroupCreatre";
import emailStore from "../../Stores/EmailNotificationStore";
import EmailConstants from "../../Constants/EmailNotificationConstants";
import EmailNotificationAction from "../../Actions/EmailNotificationAction";
import commonUtils from "../../helpers/commonUtils";
import EmailReplace from "./EmailReplace";
import { customizeFilter } from ".././FilterOptions/CustomizeFilter";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { Button } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
export default function EmailGroupList({ setDistributionGroupList }) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [emailGrouplist, setemailGrouplist] = useState(null);
  const [resEmailGrouplist, setResemailGrouplist] = useState([]);
  const [emailGroupDetails, setEmailGroupDetails] = useState("");
  const columns = [
    { field: "emails", headerName: localization.emails, hideable: false },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    { field: "groupTitle", headerName: localization.name },
  ];

  const getDistributionGroup = () => {
    setGlobalSpinner(true);
    EmailNotificationAction.getEmailDistributionGroup();
  };
  /* <>--------------------------------------------------------------------Get Email Distribution Group Start----------------------------------------------------------<> */
  useEffect(() => {
    getDistributionGroup();
    function getEmailDistrubtionGroupSuccess() {
      var res = emailStore.getResult();
      if (res.length > 0) {
        const _item = res.map((item) => ({
          ...item,
          ["emails"]: arrayToString(item.emails),
        }));
        setResemailGrouplist(res);
        setemailGrouplist(_item);
        setDistributionGroupList(res);
      } else {
        setemailGrouplist([]);
        setResemailGrouplist([]);
        setDistributionGroupList([]);
      }
      setGlobalSpinner(false);
    }

    function getEmailDistrubtionGroupFailure() {
      var res = emailStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    emailStore.addChangeListener(
      EmailConstants.GET_EMAIL_DISTRIBUTION_GROUP_SUCCESS,
      getEmailDistrubtionGroupSuccess,
    );

    emailStore.addChangeListener(
      EmailConstants.GET_EMAIL_DISTRIBUTION_GROUP_FAILURE,
      getEmailDistrubtionGroupFailure,
    );
    return () => {
      emailStore.removeChangeListener(
        EmailConstants.GET_EMAIL_DISTRIBUTION_GROUP_SUCCESS,
        getEmailDistrubtionGroupSuccess,
      );

      emailStore.removeChangeListener(
        EmailConstants.GET_EMAIL_DISTRIBUTION_GROUP_FAILURE,
        getEmailDistrubtionGroupFailure,
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Get Email Distribution Group End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------ADD OR Update Email distribution group Start----------------------------------------------------------<> */
  useEffect(() => {
    function saveORUpdateEmailDistributionGroupSucess() {
      var res = emailStore.getResult();
      commonUtils.hideModalPopUp("addEmailSchedularModalClose");
      EmailNotificationAction.getEmailDistributionGroup();
      toast.success(
        commonUtils.getIsEdit()
          ? localization.editGroupSucess
          : localization.createGroupSucess,
      );
    }

    function saveORUpdateEmailDistributionGroupFailure() {
      var res = emailStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    emailStore.addChangeListener(
      EmailConstants.ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_SUCCESS,
      saveORUpdateEmailDistributionGroupSucess,
    );

    emailStore.addChangeListener(
      EmailConstants.ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_FAILURE,
      saveORUpdateEmailDistributionGroupFailure,
    );
    return () => {
      emailStore.removeChangeListener(
        EmailConstants.ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_SUCCESS,
        saveORUpdateEmailDistributionGroupSucess,
      );

      emailStore.removeChangeListener(
        EmailConstants.ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_FAILURE,
        saveORUpdateEmailDistributionGroupFailure,
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------ADD OR Update Email distribution group End----------------------------------------------------------<> */
  function handleEditGroup(row) {
    setEmailGroupDetails(row);
  }
  function RenderAction() {
    return (
      <>
        <Button
          variant="outlined"
          id="emailSchedularId"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<MdEdit />}
          data-toggle="modal"
          data-target="#addEmailGroup"
        >
          {localization.editButton}
        </Button>
      </>
    );
  }

  function handleAddEmailGroup() {
    setEmailGroupDetails("");
  }
  function RenderAddEmailGroup() {
    return (
      <>
        <Button
          variant="outlined"
          id="addEmailGroupId"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<MdOutlineQueue />}
          data-toggle="modal"
          data-target="#addEmailGroup"
        >
          {localization.createGroup}
        </Button>
      </>
    );
  }

  function handleEmailReplace() {
    setEmailGroupDetails("");
  }
  function RenderReplaceEmail() {
    return (
      <>
        <Button
          variant="outlined"
          id="replaceEmail"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<MdOutlineQueue />}
          data-toggle="modal"
          data-target="#addreplaceEmail"
        >
          {localization.replaceButton}
        </Button>
      </>
    );
  }

  const operations = {
    RowOperationList: [
      {
        label: "EditEmailGroup",
        component: <RenderAction />,
        onClick: handleEditGroup,
      },
    ],
    GridToolBarAction: [
      {
        label: "AddEmailGroup",
        component: <RenderAddEmailGroup />,
        onClick: handleAddEmailGroup,
      },
      {
        label: "ReplaceEmail",
        component: <RenderReplaceEmail />,
        onClick: handleEmailReplace,
      },
    ],
  };
  function getAction(params) {
    const _acionList = [];

    _acionList.push(
      <GridActionsCellItem
        label={localization.editButton}
        showInMenu
        onClick={() => handleEditGroup(params.row)}
        data-toggle="modal"
        data-target="#addEmailGroup"
      />,
    );
    return _acionList;
  }
  return (
    <>
      <EmailGroupCreatre
        emailGroupDetails={emailGroupDetails}
        setEmailGroupDetails={setEmailGroupDetails}
      />
      <EmailReplace getDistributionGroup={getDistributionGroup} />
      <div className="w-100 h-100 mt-4">
        {emailGrouplist && (
          <CustomDataGrid
            Title={localization.genSetting + " / " + localization.emailGroup}
            columns={columns}
            rows={emailGrouplist}
            operations={operations}
            onAdd={() => {}}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["emails", "groupTitle"]}
            showCheckBox={false}
            gridTableHeight={"dataGridSmall"}
          />
        )}
      </div>
    </>
  );
}

function arrayToString(arrayElements) {
  if (arrayElements.length > 0) {
    return arrayElements.join(",");
  }
}
